const less10 = value => (value < 10 ? "0" + value : value);

const secons2Dhm = sec => {
  var seconds = parseInt(sec, 10);

  var days = Math.floor(seconds / (3600 * 24));
  seconds -= days * 3600 * 24;
  var hrs = Math.floor(seconds / 3600);
  seconds -= hrs * 3600;
  var mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;

  return days + " " + less10(hrs) + ":" + less10(mnts);
};


const secons2text = sec => {
  let response = "";
  let seconds = parseInt(sec, 10);
  let days = Math.floor(seconds / (3600 * 24));
  let hrs = Math.floor(seconds / 3600);
  let mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;

  if(days > 0 && days === 1) response += days + " día ";
  if(days > 1 ) response += days + " días ";
  if(hrs > 0 && hrs === 1) response += hrs + " hora y ";
  if(hrs > 1) response += hrs + " horas y ";
  if(mnts > 0 && mnts === 1) response += mnts + " minuto y ";
  if(mnts > 1) response += mnts + " minutos y ";
  response += seconds + " segundos ";

  return response;
};

module.exports = {
  secons2Dhm,
  secons2text
};
